import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-jason-blog/src/templates/page.js";
import { Button } from '$components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`If you want to contact me, here’s how to do it:`}</p>
    <h2>{`Reach Out on Social Media`}</h2>
    <p>{`For most quick questions, I prefer social media because:`}</p>
    <ol>
      <li parentName="ol">{`The discussion might benefit other people`}</li>
      <li parentName="ol">{`Other smart people might have better thoughts than I do`}</li>
      <li parentName="ol">{`Social media encourages brevity`}</li>
    </ol>
    <p>{`I’m most active on `}<a parentName="p" {...{
        "href": "https://twitter.com/jlengstorf"
      }}>{`Twitter`}</a>{`, but you can also find me on `}<a parentName="p" {...{
        "href": "https://www.facebook.com/jlengstorf"
      }}>{`Facebook`}</a>{`.`}</p>
    <Button href="https://twitter.com/intent/tweet?related=jlengstorf&text=Hey%20%40jlengstorf%2C%20I%20have%20things%20to%20say." small mdxType="Button">
  Tweet at Me
    </Button>
    <h2>{`Set Up a Call for In-Depth Questions`}</h2>
    <p>{`If you question requires more than 280 characters in response, it’s probably pushing into consulting territory. And that’s okay — I’m always happy to do coaching and consulting calls — but I do charge for my time.`}</p>
    <p>{`To make this easy and charge per-minute, I use `}<a parentName="p" {...{
        "href": "https://clarity.fm/jlengstorf"
      }}>{`Clarity`}</a>{`. If you want to get into details, talk specifics, or even put together a personalized action plan for you or your business, request a 15-minute call and we’ll do amazing things together.`}</p>
    <h2>{`Or Send Me an Email — But Be Patient`}</h2>
    <p>{`If you `}<em parentName="p">{`really`}</em>{` love email for some reason, you can also send an email to `}<a parentName="p" {...{
        "href": "mailto:jason@lengstorf.com"
      }}>{`jason@lengstorf.com`}</a>{`. But be patient: I don’t check it all that often, and I prioritize email below pretty much everything else.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      